import { render, staticRenderFns } from "./SitePanel.vue?vue&type=template&id=5482dbcb&scoped=true"
import script from "./SitePanel.vue?vue&type=script&lang=js"
export * from "./SitePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5482dbcb",
  null
  
)

export default component.exports